import React, { Component } from "react";
//PrimeReact Components
import * as pr from "../../common/PrimeComponents";
//Common
import * as fo from "../../common/FormatFunctions";
import { LoadScreen } from "../../common/LoadScreen";
import { api } from "../../common/ApiPromisify";
//ClientLibsReference
import { Belfastpilatesappspotcom } from "../../common/ClientLibsReference";

export class Business extends Component {
  constructor() {
    super();
    this.state = {
      loaded: false,
      businessLastUpdatedDateTime: "",
      initialBusinessName: "",
      businessName: "",
      businessAddressLine1: "",
      businessAddressLine2: "",
      businessTown: "",
      businessPostcode: "",
      businessCurrency: "",
      businessCountry: "",
      businessTelephone: "",
      businessEmail: "",
      editBusinessName: "",
      editBusinessAddressLine1: "",
      editBusinessAddressLine2: "",
      editBusinessTown: "",
      editBusinessPostcode: "",
      editBusinessCurrency: "",
      editBusinessCountry: "",
      editBusinessTelephone: "",
      editBusinessEmail: "",
      mondayStart: "",
      mondayEnd: "",
      tuesdayStart: "",
      tuesdayEnd: "",
      wednesdayStart: "",
      wednesdayEnd: "",
      thursdayStart: "",
      thursdayEnd: "",
      fridayStart: "",
      fridayEnd: "",
      saturdayStart: "",
      saturdayEnd: "",
      sundayStart: "",
      sundayEnd: "",
      editMondayStart: "",
      editMondayEnd: "",
      editTuesdayStart: "",
      editTuesdayEnd: "",
      editWednesdayStart: "",
      editWednesdayEnd: "",
      editThursdayStart: "",
      editThursdayEnd: "",
      editFridayStart: "",
      editFridayEnd: "",
      editSaturdayStart: "",
      editSaturdayEnd: "",
      editSundayStart: "",
      editSundayEnd: "",
      mondayClosed: false,
      tuesdayClosed: false,
      wednesdayClosed: false,
      thursdayClosed: false,
      fridayClosed: false,
      saturdayClosed: false,
      sundayClosed: false,
      editMondayClosed: false,
      editTuesdayClosed: false,
      editWednesdayClosed: false,
      editThursdayClosed: false,
      editFridayClosed: false,
      editSaturdayClosed: false,
      editSundayClosed: false,
      correspondOpeningTimes: false,
      considerBankHolidays: false,
      considerEmployeeWorkingHours: false,
      considerEmployeeAnnualLeave: false,
      editCorrespondOpeningTimes: false,
      editConsiderBankHolidays: false,
      editConsiderEmployeeWorkingHours: false,
      editConsiderEmployeeAnnualLeave: false,
      weeklyNews: "",
      generalInformation: "",
      editWeeklyNews: "",
      editGeneralInformation: "",
      editingBusiness: false,
      editingTimes: false,
      editingRules: false,
      editingNews: false,
      editingInformation: false,
      ruleId: "",
      lastUpdatedDateTime2: "",
      timeString: "",
      timeJSON: "",
      // Holidays
      holidaysSelected: false,
      holidayAdded: false,
      setStartDate: "",
      setEndDate: "",
      datesReturned: [],
      displayCreateButton: false,
      holidayList: [],
      holidayExpandedRows: false,
      holidayCreateView: false
    };

    this.displayDates = this.displayDates.bind(this);
    this.displayHolidayTableView = this.displayHolidayTableView.bind(this);
    this.displayHolidayCreateView = this.displayHolidayCreateView.bind(this);
  }

  componentDidMount = () => {
    this.getRules();
    this.getBusiness();
    this.getCalendarByType();
  };

  getRules = async () => {
    let ruleRequest = new Belfastpilatesappspotcom.RuleRequest();
    ruleRequest.codeTag = localStorage.getItem("globalBid");

    await api("ruleApiV1RuleListForBusiness", ruleRequest).then(res => {
      if (res.data) {
        if (Array.isArray(res.data.ruleList)) {
          res.data.ruleList.forEach(e => {
            e.lastUpdatedDateTime = e.lastUpdatedDateTime.toJSON();
          });

          let ruleResponse = Belfastpilatesappspotcom.RuleResponse.constructFromObject(
            res.data
          );
          console.log(ruleResponse);

          if (res.data.errorCode === 0) {
            this.setState({
              ruleId: ruleResponse.ruleList[0].id,
              lastUpdatedDateTime2:
                ruleResponse.ruleList[0].lastUpdatedDateTime,
              correspondOpeningTimes: ruleResponse.ruleList[0].useWorkingWeek,
              considerBankHolidays: ruleResponse.ruleList[0].useBankHolidays,
              considerEmployeeWorkingHours:
                ruleResponse.ruleList[0].useEmployeeAvailabilty,
              considerEmployeeAnnualLeave:
                ruleResponse.ruleList[0].useEmployeeHolidays
            });
          } else {
            this.growl.show({
              severity: "error",
              summary: "Error",
              detail:
                "Rules could not be retrieved, please refresh and try again",
              life: 3000
            });
          }
        }
      } else {
        console.log("ruleApiV1RuleListForBusiness has failed");
      }
    });
  };

  updateRules = async () => {
    let ruleRequest = new Belfastpilatesappspotcom.RuleRequest();
    ruleRequest.codeTag = localStorage.getItem("globalBid");
    ruleRequest.userId = localStorage.getItem("userId");
    ruleRequest.id = this.state.ruleId;
    ruleRequest.lastUpdatedDateTime = this.state.lastUpdatedDateTime2;
    ruleRequest.useWorkingWeek = this.state.editCorrespondOpeningTimes;
    ruleRequest.useBankHolidays = this.state.editConsiderBankHolidays;
    ruleRequest.useEmployeeAvailabilty = this.state.editConsiderEmployeeWorkingHours;
    ruleRequest.useEmployeeHolidays = this.state.editConsiderEmployeeAnnualLeave;

    await api("ruleApiV1RuleUpdate", ruleRequest).then(res => {
      if (res.data) {
        let ruleResponse = Belfastpilatesappspotcom.RuleResponse.constructFromObject(
          res.data
        );
        console.log(ruleResponse);

        if (ruleResponse.errorCode === 0) {
          this.getRules();
        } else {
          this.growl.show({
            severity: "error",
            summary: "Error",
            detail: "Rules could not be updated, please try again",
            life: 3000
          });
        }
      } else {
        console.log("ruleApiV1RuleUpdate has failed");
      }
    });
  };

  getBusiness = async () => {
    this.setState({ loaded: false });

    let businessRequest = new Belfastpilatesappspotcom.BusinessRequest();
    businessRequest.codeTag = localStorage.getItem("globalBid");
    businessRequest.userId = localStorage.getItem("userId");

    await api("businessApiV1BusinessAccountGet", businessRequest).then(res => {
      if (res.data) {
        if (res.data.lastUpdatedDateTime) {
          res.data.lastUpdatedDateTime = res.data.lastUpdatedDateTime.toJSON();
        }

        let businessResponse = Belfastpilatesappspotcom.BusinessResponse.constructFromObject(
          res.data
        );
        console.log(businessResponse);

        if (businessResponse.errorCode === 0) {
          this.setState(
            {
              businessLastUpdatedDateTime: businessResponse.lastUpdatedDateTime,
              initialBusinessName: businessResponse.businessName,
              businessName: businessResponse.businessName,
              businessAddressLine1: businessResponse.addressLine1,
              businessAddressLine2: businessResponse.addressLine2,
              businessTown: businessResponse.city,
              businessPostcode: businessResponse.postalZipCode,
              businessCurrency: businessResponse.currency,
              businessCountry: businessResponse.country,
              businessTelephone: businessResponse.telephoneNumber,
              businessEmail: businessResponse.email,
              weeklyNews: businessResponse.weeklyInformation,
              generalInformation: businessResponse.businessDescription,
              timeString: businessResponse.openingHours
            },
            () => {
              if (this.state.timeString) {
                this.timeParse();
              }
            }
          );
        } else {
          this.growl.show({
            severity: "error",
            summary: "Error",
            detail:
              "Business could not be retrieved, please refresh and try again",
            life: 3000
          });
        }
      } else {
        console.log("businessApiV1BusinessAccountGet has failed");
      }
    });

    this.setState({ loaded: true });
  };

  timeParse = () => {
    this.setState({ timeJSON: JSON.parse(this.state.timeString) }, () => {
      console.log(this.state.timeJSON);
      this.timeSet();
    });
  };

  timeSet = () => {
    this.setState(
      {
        mondayStart: this.state.timeJSON.daysOpeningHours.MONDAY[0],
        mondayEnd: this.state.timeJSON.daysOpeningHours.MONDAY[1],
        tuesdayStart: this.state.timeJSON.daysOpeningHours.TUESDAY[0],
        tuesdayEnd: this.state.timeJSON.daysOpeningHours.TUESDAY[1],
        wednesdayStart: this.state.timeJSON.daysOpeningHours.WEDNESDAY[0],
        wednesdayEnd: this.state.timeJSON.daysOpeningHours.WEDNESDAY[1],
        thursdayStart: this.state.timeJSON.daysOpeningHours.THURSDAY[0],
        thursdayEnd: this.state.timeJSON.daysOpeningHours.THURSDAY[1],
        fridayStart: this.state.timeJSON.daysOpeningHours.FRIDAY[0],
        fridayEnd: this.state.timeJSON.daysOpeningHours.FRIDAY[1],
        saturdayStart: this.state.timeJSON.daysOpeningHours.SATURDAY[0],
        saturdayEnd: this.state.timeJSON.daysOpeningHours.SATURDAY[1],
        sundayStart: this.state.timeJSON.daysOpeningHours.SUNDAY[0],
        sundayEnd: this.state.timeJSON.daysOpeningHours.SUNDAY[1]
      },
      () => {
        if (this.state.mondayStart === 1110 && this.state.mondayEnd === 1111) {
          this.setState({ mondayClosed: true });
        } else {
          this.setState({ mondayClosed: false });
        }
        if (
          this.state.tuesdayStart === 1110 &&
          this.state.tuesdayEnd === 1111
        ) {
          this.setState({ tuesdayClosed: true });
        } else {
          this.setState({ tuesdayClosed: false });
        }
        if (
          this.state.wednesdayStart === 1110 &&
          this.state.wednesdayEnd === 1111
        ) {
          this.setState({ wednesdayClosed: true });
        } else {
          this.setState({ wednesdayClosed: false });
        }
        if (
          this.state.thursdayStart === 1110 &&
          this.state.thursdayEnd === 1111
        ) {
          this.setState({ thursdayClosed: true });
        } else {
          this.setState({ thursdayClosed: false });
        }
        if (this.state.fridayStart === 1110 && this.state.fridayEnd === 1111) {
          this.setState({ fridayClosed: true });
        } else {
          this.setState({ fridayClosed: false });
        }
        if (
          this.state.saturdayStart === 1110 &&
          this.state.saturdayEnd === 1111
        ) {
          this.setState({ saturdayClosed: true });
        } else {
          this.setState({ saturdayClosed: false });
        }
        if (this.state.sundayStart === 1110 && this.state.sundayEnd === 1111) {
          this.setState({ sundayClosed: true });
        } else {
          this.setState({ sundayClosed: false });
        }
      }
    );
  };

  updateBusinessTimes = async () => {
    let editTimeJSON = this.state.timeJSON;

    if (this.state.editMondayClosed) {
      editTimeJSON.daysOpeningHours.MONDAY[0] = "1110";
      editTimeJSON.daysOpeningHours.MONDAY[1] = "1111";
    } else {
      editTimeJSON.daysOpeningHours.MONDAY[0] = parseInt(
        this.state.editMondayStart,
        10
      );
      editTimeJSON.daysOpeningHours.MONDAY[1] = parseInt(
        this.state.editMondayEnd,
        10
      );
    }

    if (this.state.editTuesdayClosed) {
      editTimeJSON.daysOpeningHours.TUESDAY[0] = "1110";
      editTimeJSON.daysOpeningHours.TUESDAY[1] = "1111";
    } else {
      editTimeJSON.daysOpeningHours.TUESDAY[0] = parseInt(
        this.state.editTuesdayStart,
        10
      );
      editTimeJSON.daysOpeningHours.TUESDAY[1] = parseInt(
        this.state.editTuesdayEnd,
        10
      );
    }

    if (this.state.editWednesdayClosed) {
      editTimeJSON.daysOpeningHours.WEDNESDAY[0] = "1110";
      editTimeJSON.daysOpeningHours.WEDNESDAY[1] = "1111";
    } else {
      editTimeJSON.daysOpeningHours.WEDNESDAY[0] = parseInt(
        this.state.editWednesdayStart,
        10
      );
      editTimeJSON.daysOpeningHours.WEDNESDAY[1] = parseInt(
        this.state.editWednesdayEnd,
        10
      );
    }

    if (this.state.editThursdayClosed) {
      editTimeJSON.daysOpeningHours.THURSDAY[0] = "1110";
      editTimeJSON.daysOpeningHours.THURSDAY[1] = "1111";
    } else {
      editTimeJSON.daysOpeningHours.THURSDAY[0] = parseInt(
        this.state.editThursdayStart,
        10
      );
      editTimeJSON.daysOpeningHours.THURSDAY[1] = parseInt(
        this.state.editThursdayEnd,
        10
      );
    }

    if (this.state.editFridayClosed) {
      editTimeJSON.daysOpeningHours.FRIDAY[0] = "1110";
      editTimeJSON.daysOpeningHours.FRIDAY[1] = "1111";
    } else {
      editTimeJSON.daysOpeningHours.FRIDAY[0] = parseInt(
        this.state.editFridayStart,
        10
      );
      editTimeJSON.daysOpeningHours.FRIDAY[1] = parseInt(
        this.state.editFridayEnd,
        10
      );
    }

    if (this.state.editSaturdayClosed) {
      editTimeJSON.daysOpeningHours.SATURDAY[0] = "1110";
      editTimeJSON.daysOpeningHours.SATURDAY[1] = "1111";
    } else {
      editTimeJSON.daysOpeningHours.SATURDAY[0] = parseInt(
        this.state.editSaturdayStart,
        10
      );
      editTimeJSON.daysOpeningHours.SATURDAY[1] = parseInt(
        this.state.editSaturdayEnd,
        10
      );
    }

    if (this.state.editSundayClosed) {
      editTimeJSON.daysOpeningHours.SUNDAY[0] = "1110";
      editTimeJSON.daysOpeningHours.SUNDAY[1] = "1111";
    } else {
      editTimeJSON.daysOpeningHours.SUNDAY[0] = parseInt(
        this.state.editSundayStart,
        10
      );
      editTimeJSON.daysOpeningHours.SUNDAY[1] = parseInt(
        this.state.editSundayEnd,
        10
      );
    }

    let businessRequest = new Belfastpilatesappspotcom.BusinessRequest();
    businessRequest.codeTag = localStorage.getItem("globalBid");
    businessRequest.lastUpdatedDateTime = this.state.businessLastUpdatedDateTime;
    businessRequest.openingHours = JSON.stringify(editTimeJSON);

    await api("businessApiV1BusinessUpdate", businessRequest).then(res => {
      if (res.data) {
        let businessResponse = Belfastpilatesappspotcom.BusinessResponse.constructFromObject(
          res.data
        );
        console.log(businessResponse);

        if (businessResponse.errorCode === 0) {
          this.getBusiness();
        } else {
          this.growl.show({
            severity: "error",
            summary: "Error",
            detail:
              "Business opening hours could not be updated, please try again",
            life: 3000
          });
        }
      } else {
        console.log("businessApiV1BusinessUpdate has failed");
      }
    });
  };

  updateBusiness = async () => {
    if (
      !this.state.editBusinessName ||
      !this.state.editBusinessAddressLine1 ||
      !this.state.editBusinessAddressLine2 ||
      !this.state.editBusinessTown ||
      !this.state.editBusinessPostcode ||
      !this.state.editBusinessCurrency ||
      !this.state.editBusinessCountry ||
      !this.state.editBusinessTelephone ||
      !this.state.editBusinessEmail
    ) {
      this.growl.show({
        severity: "error",
        summary: "Missing Fields",
        detail: "Please fill in all fields",
        life: 3000
      });
    } else {
      let businessRequest = new Belfastpilatesappspotcom.BusinessRequest();
      businessRequest.codeTag = localStorage.getItem("globalBid");
      businessRequest.lastUpdatedDateTime = this.state.businessLastUpdatedDateTime;
      if (this.state.editBusinessName !== this.state.initialBusinessName) {
        businessRequest.businessName = this.state.editBusinessName;
      }
      businessRequest.addressLine1 = this.state.editBusinessAddressLine1;
      businessRequest.addressLine2 = this.state.editBusinessAddressLine2;
      businessRequest.city = this.state.editBusinessTown;
      businessRequest.postalZipCode = this.state.editBusinessPostcode;
      businessRequest.currency = this.state.editBusinessCurrency;
      businessRequest.country = this.state.editBusinessCountry;
      businessRequest.telephoneNumber = this.state.editBusinessTelephone;
      businessRequest.email = this.state.editBusinessEmail;

      await api("businessApiV1BusinessUpdate", businessRequest).then(res => {
        if (res.data) {
          let businessResponse = Belfastpilatesappspotcom.BusinessResponse.constructFromObject(
            res.data
          );
          console.log(businessResponse);

          if (businessResponse.errorCode === 0) {
            this.getBusiness();
          } else {
            this.growl.show({
              severity: "error",
              summary: "Error",
              detail: "Business details could not be updated, please try again",
              life: 3000
            });
          }
        } else {
          console.log("businessApiV1BusinessUpdate has failed");
        }
      });
    }
  };

  updateWeeklyNews = async () => {
    let businessRequest = new Belfastpilatesappspotcom.BusinessRequest();
    businessRequest.codeTag = localStorage.getItem("globalBid");
    businessRequest.lastUpdatedDateTime = this.state.businessLastUpdatedDateTime;
    businessRequest.weeklyInformation = this.state.editWeeklyNews;

    await api("businessApiV1BusinessUpdate", businessRequest).then(res => {
      if (res.data) {
        let businessResponse = Belfastpilatesappspotcom.BusinessResponse.constructFromObject(
          res.data
        );
        console.log(businessResponse);

        if (businessResponse.errorCode === 0) {
          this.getBusiness();
        } else {
          this.growl.show({
            severity: "error",
            summary: "Error",
            detail: "Weekly News could not be updated, please try again",
            life: 3000
          });
        }
      } else {
        console.log("businessApiV1BusinessUpdate has failed");
      }
    });
  };

  updateGeneralInformation = async () => {
    let businessRequest = new Belfastpilatesappspotcom.BusinessRequest();
    businessRequest.codeTag = localStorage.getItem("globalBid");
    businessRequest.lastUpdatedDateTime = this.state.businessLastUpdatedDateTime;
    businessRequest.businessDescription = this.state.editGeneralInformation;

    await api("businessApiV1BusinessUpdate", businessRequest).then(res => {
      if (res.data) {
        let businessResponse = Belfastpilatesappspotcom.BusinessResponse.constructFromObject(
          res.data
        );
        console.log(businessResponse);

        if (businessResponse.errorCode === 0) {
          this.getBusiness();
        } else {
          this.growl.show({
            severity: "error",
            summary: "Error",
            detail:
              "General Information could not be updated, please try again",
            life: 3000
          });
        }
      } else {
        console.log("businessApiV1BusinessUpdate has failed");
      }
    });
  };

  getDatesSelected = async () => {
    let scheduleRequest = new Belfastpilatesappspotcom.ScheduleRequest();
    scheduleRequest.codeTag = localStorage.getItem("globalBid");
    scheduleRequest.userId = localStorage.getItem("userId");
    scheduleRequest.generateStartDate = this.state.setStartDate;
    scheduleRequest.generateEndDate = this.state.setEndDate;
    scheduleRequest.recurrenceType = "DAILY";

    await api("scheduleApiV1ScheduleGetListOfDates", scheduleRequest).then(
      res => {
        if (res.data) {
          if (Array.isArray(res.data.scheduleList)) {
            res.data.scheduleList.forEach(e => {
              if (e.lastUpdatedDateTime) {
                e.lastUpdatedDateTime = e.lastUpdatedDateTime.toJSON();
              }
              if (e.dateCreated) {
                e.dateCreated = e.dateCreated.toJSON();
              }
            });
          }

          let scheduleResponse = Belfastpilatesappspotcom.ScheduleResponse.constructFromObject(
            res.data
          );
          console.log(scheduleResponse);

          if (scheduleResponse.errorCode === 0) {
            this.growl.show({
              severity: "success",
              summary: "Success",
              detail: "Dates retrieved",
              life: 3000
            });
            this.setState({
              datesReturned: scheduleResponse.scheduleList,
              displayCreateButton: true
            });
          } else {
            this.growl.show({
              severity: "error",
              summary: "Error",
              detail: "Dates could not be retrieved for selected range",
              life: 3000
            });
          }
        } else {
          console.log("scheduleApiV1ScheduleGetListOfDates has failed");
        }
      }
    );
  };

  getCalendarByType = async () => {
    let calendarRequest = new Belfastpilatesappspotcom.CalendarRequest();
    calendarRequest.codeTag = localStorage.getItem("globalBid");
    calendarRequest.userId = localStorage.getItem("userId");
    calendarRequest.type = "BH"; //BankHoliday = Will operate the same as a business holiday

    await api("calendarApiV1CalendarGetByType", calendarRequest).then(res => {
      if (res.data) {
        if (Array.isArray(res.data.calendarList)) {
          res.data.calendarList.forEach(e => {
            if (e.lastUpdatedDateTime) {
              e.lastUpdatedDateTime = e.lastUpdatedDateTime.toJSON();
            }
            if (e.dateCreated) {
              e.dateCreated = e.dateCreated.toJSON();
            }
          });
        }

        let calendarResponse = Belfastpilatesappspotcom.CalendarResponse.constructFromObject(
          res.data
        );
        console.log(calendarResponse);

        if (calendarResponse.errorCode === 0) {
          this.setState({
            holidayList: calendarResponse.calendarList,
            holidaysSelected: true
          });
        } else {
          this.growl.show({
            severity: "error",
            summary: "Error",
            detail: "Holidays could not be retrieved",
            life: 3000
          });
        }
      } else {
        console.log("calendarApiV1CalendarListForUser has failed");
      }
    });
  };

  calendarDelete = async data => {
    let calendarRequest = new Belfastpilatesappspotcom.CalendarRequest();
    calendarRequest.codeTag = localStorage.getItem("globalBid");
    calendarRequest.userId = localStorage.getItem("userId");
    calendarRequest.id = data.id;
    calendarRequest.lastUpdatedDateTime = data.lastUpdatedDateTime;

    await api("calendarApiV1CalendarDelete", calendarRequest).then(res => {
      if (res.data) {
        let calendarResponse = Belfastpilatesappspotcom.CalendarResponse.constructFromObject(
          res.data
        );
        console.log(calendarResponse);

        if (calendarResponse.errorCode === 0) {
          this.growl.show({
            severity: "success",
            summary: "Success",
            detail: "Holiday deleted",
            life: 3000
          });
          let holidays = this.state.holidayList;
          let i = 0;

          if (Array.isArray(holidays)) {
            holidays.forEach(e => {
              if (calendarResponse.id === e.id || data.id === e.id) {
                holidays.splice(i, 1);
              }
              i++;
            });
          }

          this.setState({
            holidaysSelected: true,
            holidayList: holidays
          });
        } else {
          this.growl.show({
            severity: "error",
            summary: "Error",
            detail: "Holiday could not be deleted, please try again",
            life: 3000
          });
        }
      } else {
        console.log("calendarApiV1CalendarDelete has failed");
      }
    });
  };

  createHoliday = async () => {
    let calendarRequest = new Belfastpilatesappspotcom.CalendarRequest();
    calendarRequest.codeTag = localStorage.getItem("globalBid");
    calendarRequest.userId = localStorage.getItem("userId");
    calendarRequest.countryCode = localStorage.getItem("countryCode");
    calendarRequest.type = "BH";

    let datesJson = {};
    let daysOpeningHours = {};

    if (this.state.datesReturned) {
      this.state.datesReturned.forEach(bean => {
        let times = [];

        if (bean.startTime) {
          times[0] = fo.formatDate(bean.startTime, "hhmm");
        } else {
          times[0] = "1110";
        }

        if (bean.endTime) {
          times[1] = fo.formatDate(bean.endTime, "hhmm");
        } else {
          times[1] = "1111";
        }
        
        daysOpeningHours[bean.displayDate] = times;
      });

      datesJson.daysOpeningHours = daysOpeningHours;
    }

    calendarRequest.availableHours = JSON.stringify(datesJson);

    await api("calendarApiV1CalendarGenerateSetDates", calendarRequest).then(
      res => {
        if (res.data) {
          let calendarResponse = Belfastpilatesappspotcom.CalendarResponse.constructFromObject(
            res.data
          );
          console.log(calendarResponse);

          if (calendarResponse.errorCode === 0) {
            this.growl.show({
              severity: "success",
              summary: "Success",
              detail: "User holiday successfully created",
              life: 3000
            });
            this.setState(
              {
                datesReturned: [],
                holidaysSelected: true,
                holidayList: [],
                holidayCreateView: false,
                setStartDate: "",
                setEndDate: ""
              },
              () => {
                this.getCalendarByType();
              }
            );
          } else {
            this.growl.show({
              severity: "error",
              summary: "Error",
              detail: "User holiday not created, please try again",
              life: 3000
            });
          }
        } else {
          console.log("calendarApiV1CalendarGenerateSetDates has failed");
        }
      }
    );
  };

  updateDatesTime = (e, field, value) => {
    var bean = this.state.datesReturned;

    if (Array.isArray(bean)) {
      bean.forEach(date => {
        if (date.displayDate === e.displayDate) {
          if (field === "dayChecked") {
            if (value) {
              date[field] = value;
            } else {
              date[field] = value;
              this.updateDatesTime(e, "startTime", "");
              this.updateDatesTime(e, "endTime", "");
            }
          } else {
            date[field] = value;
          }
        }
      });
    }

    this.setState({
      datesReturned: bean
    });
  };

  getTimeInputs = e => {
    if (e.dayChecked) {
      return (
        <div>
          <div className="ui-g-6">
            <pr.Calendar
              value={e.startTime || ""}
              onChange={g => {
                this.updateDatesTime(e, "startTime", g.value);
              }}
              timeOnly={true}
              hourFormat="24"
              inputStyle={{
                width: "100%"
              }}
              placeholder="Start"
            />
          </div>
          <div className="ui-g-6">
            <pr.Calendar
              value={e.endTime || ""}
              onChange={g => {
                this.updateDatesTime(e, "endTime", g.value);
              }}
              timeOnly={true}
              hourFormat="24"
              inputStyle={{
                width: "100%"
              }}
              placeholder="End"
            />
          </div>
        </div>
      );
    } else {
      return <label />;
    }
  };

  displaySingleDate = e => {
    return (
      <div className="ui-g-12">
        <div className="ui-g-6">
          <b>{e.displayDay + " - " + e.displayDate}</b>
        </div>
        <div className="ui-g-6">
          <label>Custom time? </label>
          <pr.Checkbox
            onChange={g => this.updateDatesTime(e, "dayChecked", g.checked)}
            checked={
              this.state.datesReturned[
                this.state.datesReturned.findIndex(
                  p => p.displayDate === e.displayDate
                )
              ].dayChecked
            }
            style={{ align: "middle" }}
          />
        </div>
        <div className="ui-g-6">{this.getTimeInputs(e)}</div>
      </div>
    );
  };

  displayDates = () => {
    let datesToDisplay = [];
    let i = 0;

    if (Array.isArray(this.state.datesReturned)) {
      this.state.datesReturned.forEach(e => {
        if (e.displayDay && e.displayDate) {
          datesToDisplay[i] = this.displaySingleDate(e);
          i++;
        }
      });
    }

    return datesToDisplay;
  };

  displayHolidayCreateView = () => {
    return (
      <div className="ui-g-12 ui-md-12">
        <label>Select date range you wish to book off</label>
        <div className="ui-g-12">
          <div className="ui-g-4">
            <pr.Calendar
              placeholder="From Date"
              value={this.state.setStartDate}
              onChange={e => this.setState({ setStartDate: e.value })}
              showTime={false}
              showSeconds={false}
              dateFormat="dd/mm/yy"
            />
          </div>
          <div className="ui-g-4">
            <pr.Calendar
              placeholder="To Date"
              value={this.state.setEndDate}
              onChange={e => this.setState({ setEndDate: e.value })}
              showTime={false}
              showSeconds={false}
              dateFormat="dd/mm/yy"
            />
          </div>
          <div className="ui-g-12">
            {this.state.setStartDate && this.state.setEndDate ? (
              <pr.Button
                label="Get Dates selected"
                onClick={() => {
                  this.getDatesSelected();
                }}
                style={{ float: "right" }}
              />
            ) : (
              <label />
            )}
            <pr.Button
              label="Cancel"
              onClick={() => {
                this.setState({
                  holidaysSelected: true,
                  datesReturned: [],
                  setStartDate: "",
                  setEndDate: "",
                  holidayCreateView: false
                });
              }}
              style={{ float: "right" }}
            />
          </div>
        </div>

        <div className="ui-g-12" style={{ paddingTop: "20px" }}>
          {this.displayDates()}
        </div>
        {/* Display button to run create holiday sequence */}
        {this.state.displayCreateButton ? (
          <div className="ui-g-12">
            <pr.Button
              label="Create Holiday"
              onClick={() => {
                this.createHoliday();
              }}
              style={{ float: "right" }}
            />
            <pr.Button
              label="Cancel"
              onClick={() => {
                this.setState({
                  holidayCreateView: false,
                  datesReturned: [],
                  displayCreateButton: false,
                  setStartDate: "",
                  setEndDate: "",
                  holidaysSelected: true
                });
              }}
              style={{ float: "right" }}
            />
          </div>
        ) : (
          <label />
        )}
      </div>
    );
  };

  displayHolidayTableView = () => {
    return (
      <div className={"ui-g-12 ui-md-12"}>
        <div className="ui-g-12">
          <pr.Button
            label="Create Holiday"
            icon="pi pi-calendar"
            onClick={() => {
              this.setState({
                holidaysSelected: false,
                holidayCreateView: true
              });
            }}
            style={{ float: "right" }}
          />
        </div>
        <div className="ui-g-12">
          <pr.DataTable
            value={this.state.holidayList}
            expandedRows={this.state.holidayExpandedRows}
            onRowToggle={e =>
              this.setState({
                holidayExpandedRows: e.data
              })
            }
            rowExpansionTemplate={this.getHolidaySelectionView}
            header="Business Holidays"
            autoLayout={true}
            paginator={false}
            alwaysShowPaginator={false}
            scrollable={true}
          >
            <pr.Column expander={true} style={{ width: "3em" }} />
            <pr.Column
              field=""
              body={e => {
                let date = "";
                date = e.day + "/" + e.month + "/" + e.year;
                return date;
              }}
              header="Date"
              sortable={false}
              filter={false}
              style={{ overflow: "auto" }}
            />
            <pr.Column
              field="dayOfWeek"
              header="Day Of Week"
              sortable={true}
              filter={true}
              style={{ overflow: "auto" }}
            />
            <pr.Column
              field="startTime"
              header="From"
              body={e => {
                let time = "";
                if (e.startTime === "1110" || e.startTime === "11:10") {
                  time = "All Day";
                } else {
                  time = e.startTime;
                }
                return time;
              }}
              sortable={true}
              filter={true}
              style={{ overflow: "auto" }}
            />
            <pr.Column
              field="endTime"
              header="To"
              body={e => {
                let time = "";
                if (e.endTime === "1111" || e.endTime === "11:11") {
                  time = "All Day";
                } else {
                  time = e.endTime;
                }
                return time;
              }}
              sortable={true}
              filter={true}
              style={{ overflow: "auto" }}
            />
          </pr.DataTable>
        </div>
      </div>
    );
  };

  getHolidaySelectionView = data => {
    return (
      <div
        className={
          localStorage.getItem("roleType") !== "10"
            ? "ui-g-12"
            : "ui-g-12 ui-md-12"
        }
      >
        <div className="ui-g-12">
          <pr.Button
            className="secondary-btn"
            label="Delete"
            icon="pi pi-trash"
            onClick={() => {
              this.calendarDelete(data);
            }}
            style={{ float: "right" }}
          />
        </div>
        <div className="ui-g-12">
          <b>Date: </b>
          <label>{data.day + "/" + data.month + "/" + data.year || ""}</label>
        </div>
        <div className="ui-g-12">
          <b>Day of the week: </b>
          <label>{data.dayOfWeek || ""}</label>
        </div>
        <div className="ui-g-12">
          <b>Start Time: </b>
          {data.startTime === "11:10" || data.startTime === "1110" ? (
            <label>All Day</label>
          ) : (
            <label>{data.startTime}</label>
          )}
        </div>
        <div className="ui-g-12">
          <b>End Time: </b>
          {data.endTime === "11:11" || data.endTime === "1111" ? (
            <label>All Day</label>
          ) : (
            <label>{data.endTime}</label>
          )}
        </div>
      </div>
    );
  };

  render() {
    const currencyOptions = [
      { label: "£", value: "GBP" },
      { label: "€", value: "EUR" }
    ];

    if (!this.state.loaded) {
      return (
        <center>
          <pr.Growl
            style={{ textAlign: "left" }}
            ref={el => (this.growl = el)}
          />
          <LoadScreen />
        </center>
      );
    }
    return (
      <div className="ui-g dashboard">
        <pr.Growl style={{ textAlign: "left" }} ref={el => (this.growl = el)} />
        {this.state.editingBusiness ? (
          <label />
        ) : (
          <div className="ui-g card">
            <div className="ui-g-12">
              <pr.Button
                className="secondary-btn"
                icon="pi pi-pencil"
                onClick={() => {
                  this.setState({
                    editingBusiness: true,
                    editBusinessName: this.state.businessName,
                    editBusinessAddressLine1: this.state.businessAddressLine1,
                    editBusinessAddressLine2: this.state.businessAddressLine2,
                    editBusinessTown: this.state.businessTown,
                    editBusinessPostcode: this.state.businessPostcode,
                    editBusinessCurrency: this.state.businessCurrency,
                    editBusinessCountry: this.state.businessCountry,
                    editBusinessTelephone: this.state.businessTelephone,
                    editBusinessEmail: this.state.businessEmail
                  });
                }}
                style={{ float: "right" }}
              />
            </div>

            <div className="ui-g-6">
              <div className="ui-g-12">
                <b>Business Name: </b>
                <label>{this.state.businessName || "Not Set"}</label>
              </div>
              <div className="ui-g-12">
                <b>Address Line 1: </b>
                <label>{this.state.businessAddressLine1 || "Not Set"}</label>
              </div>
              <div className="ui-g-12">
                <b>Address Line 2: </b>
                <label>{this.state.businessAddressLine2 || "Not Set"}</label>
              </div>
              <div className="ui-g-12">
                <b>Town/City: </b>
                <label>{this.state.businessTown || "Not Set"}</label>
              </div>
              <div className="ui-g-12">
                <b>Postcode: </b>
                <label>{this.state.businessPostcode || "Not Set"}</label>
              </div>
            </div>

            <div className="ui-g-6">
              <div className="ui-g-12">
                <b>Currency: </b>
                <label>{this.state.businessCurrency || "Not Set"}</label>
              </div>
              <div className="ui-g-12">
                <b>Country: </b>
                <label>{this.state.businessCountry || "Not Set"}</label>
              </div>
              <div className="ui-g-12">
                <b>Telephone: </b>
                <label>{this.state.businessTelephone || "Not Set"}</label>
              </div>
              <div className="ui-g-12">
                <b>Email Address: </b>
                <label>{this.state.businessEmail || "Not Set"}</label>
              </div>
            </div>

            <div className="ui-g-12">
              <pr.Button
                label="View Employees"
                onClick={() => {
                  window.location = "#/employees";
                }}
                style={{ float: "right" }}
              />
            </div>
          </div>
        )}

        {!this.state.editingBusiness ? (
          <label />
        ) : (
          <div className="ui-g card">
            <div className="ui-g-12">
              <pr.Button
                className="secondary-btn"
                icon="pi pi-times"
                onClick={() => {
                  this.setState({
                    editingBusiness: false
                  });
                }}
                style={{ float: "right" }}
              />
            </div>

            <div className="ui-g-6">
              <div className="ui-g-12" style={{ paddingTop: "20px" }}>
                <span className="md-inputfield form-field">
                  <input
                    className={
                      this.state.editBusinessName === ""
                        ? "ui-inputtext"
                        : "ui-inputtext ui-state-filled"
                    }
                    type="text"
                    value={this.state.editBusinessName || ""}
                    onChange={e =>
                      this.setState({ editBusinessName: e.target.value })
                    }
                  />
                  <label>Business Name</label>
                </span>
              </div>
              <div className="ui-g-12" style={{ paddingTop: "20px" }}>
                <span className="md-inputfield form-field">
                  <input
                    className={
                      this.state.editBusinessAddressLine1 === ""
                        ? "ui-inputtext"
                        : "ui-inputtext ui-state-filled"
                    }
                    type="text"
                    value={this.state.editBusinessAddressLine1 || ""}
                    onChange={e =>
                      this.setState({
                        editBusinessAddressLine1: e.target.value
                      })
                    }
                  />
                  <label>Address Line 1</label>
                </span>
              </div>
              <div className="ui-g-12" style={{ paddingTop: "20px" }}>
                <span className="md-inputfield form-field">
                  <input
                    className={
                      this.state.editBusinessAddressLine2 === ""
                        ? "ui-inputtext"
                        : "ui-inputtext ui-state-filled"
                    }
                    type="text"
                    value={this.state.editBusinessAddressLine2 || ""}
                    onChange={e =>
                      this.setState({
                        editBusinessAddressLine2: e.target.value
                      })
                    }
                  />
                  <label>Address Line 2</label>
                </span>
              </div>
              <div className="ui-g-12" style={{ paddingTop: "20px" }}>
                <span className="md-inputfield form-field">
                  <input
                    className={
                      this.state.editBusinessTown === ""
                        ? "ui-inputtext"
                        : "ui-inputtext ui-state-filled"
                    }
                    type="text"
                    value={this.state.editBusinessTown || ""}
                    onChange={e =>
                      this.setState({ editBusinessTown: e.target.value })
                    }
                  />
                  <label>Town/City</label>
                </span>
              </div>
              <div className="ui-g-12" style={{ paddingTop: "20px" }}>
                <span className="md-inputfield form-field">
                  <input
                    className={
                      this.state.editBusinessPostcode === ""
                        ? "ui-inputtext"
                        : "ui-inputtext ui-state-filled"
                    }
                    type="text"
                    value={this.state.editBusinessPostcode || ""}
                    onChange={e =>
                      this.setState({
                        editBusinessPostcode: e.target.value
                      })
                    }
                  />
                  <label>Postcode</label>
                </span>
              </div>
            </div>

            <div className="ui-g-6">
              <div className="ui-g-12" style={{ paddingTop: "10px" }}>
                <label>Currency </label>
                <pr.Dropdown
                  value={this.state.editBusinessCurrency || ""}
                  options={currencyOptions}
                  onChange={e => {
                    this.setState({ editBusinessCurrency: e.value });
                  }}
                />
              </div>
              <div className="ui-g-12" style={{ paddingTop: "20px" }}>
                <span className="md-inputfield form-field">
                  <input
                    className={
                      this.state.editBusinessCountry === ""
                        ? "ui-inputtext"
                        : "ui-inputtext ui-state-filled"
                    }
                    type="text"
                    value={this.state.editBusinessCountry || ""}
                    onChange={e =>
                      this.setState({
                        editBusinessCountry: e.target.value
                      })
                    }
                  />
                  <label>Country</label>
                </span>
              </div>
              <div className="ui-g-12" style={{ paddingTop: "20px" }}>
                <span className="md-inputfield form-field">
                  <input
                    className={
                      this.state.editBusinessTelephone === ""
                        ? "ui-inputtext"
                        : "ui-inputtext ui-state-filled"
                    }
                    type="text"
                    value={this.state.editBusinessTelephone || ""}
                    onChange={e =>
                      this.setState({
                        editBusinessTelephone: e.target.value
                      })
                    }
                  />
                  <label>Telephone</label>
                </span>
              </div>
              <div className="ui-g-12" style={{ paddingTop: "20px" }}>
                <span className="md-inputfield form-field">
                  <input
                    className={
                      this.state.editBusinessEmail === ""
                        ? "ui-inputtext"
                        : "ui-inputtext ui-state-filled"
                    }
                    type="text"
                    value={this.state.editBusinessEmail || ""}
                    onChange={e =>
                      this.setState({
                        editBusinessEmail: e.target.value
                      })
                    }
                  />
                  <label>Email Address</label>
                </span>
              </div>
            </div>

            <div className="ui-g-12">
              <pr.Button
                label="Save"
                onClick={() => {
                  this.updateBusiness();
                  this.setState({ editingBusiness: false });
                }}
                style={{ float: "right" }}
              />
              <pr.Button
                label="Cancel"
                onClick={() => {
                  this.setState({ editingBusiness: false });
                }}
                style={{ float: "right" }}
              />
            </div>
          </div>
        )}

        {this.state.editingTimes ? (
          <label />
        ) : (
          <div className="ui-g card">
            <div className="ui-g-12">
              <pr.Button
                className="secondary-btn"
                icon="pi pi-pencil"
                onClick={() => {
                  this.setState({
                    editingTimes: true,
                    editMondayStart: this.state.mondayStart,
                    editMondayEnd: this.state.mondayEnd,
                    editTuesdayStart: this.state.tuesdayStart,
                    editTuesdayEnd: this.state.tuesdayEnd,
                    editWednesdayStart: this.state.wednesdayStart,
                    editWednesdayEnd: this.state.wednesdayEnd,
                    editThursdayStart: this.state.thursdayStart,
                    editThursdayEnd: this.state.thursdayEnd,
                    editFridayStart: this.state.fridayStart,
                    editFridayEnd: this.state.fridayEnd,
                    editSaturdayStart: this.state.saturdayStart,
                    editSaturdayEnd: this.state.saturdayEnd,
                    editSundayStart: this.state.sundayStart,
                    editSundayEnd: this.state.sundayEnd,
                    editMondayClosed: this.state.mondayClosed,
                    editTuesdayClosed: this.state.tuesdayClosed,
                    editWednesdayClosed: this.state.wednesdayClosed,
                    editThursdayClosed: this.state.thursdayClosed,
                    editFridayClosed: this.state.fridayClosed,
                    editSaturdayClosed: this.state.saturdayClosed,
                    editSundayClosed: this.state.sundayClosed
                  });
                }}
                style={{ float: "right" }}
              />
            </div>
            <div className="ui-g-3">
              <div className="ui-g-12">
                <b>&nbsp;</b>
              </div>
              <div className="ui-g-12">
                <b>Monday</b>
              </div>
              <div className="ui-g-12" style={{ paddingTop: "10px" }}>
                <b>Tuesday</b>
              </div>
              <div className="ui-g-12" style={{ paddingTop: "10px" }}>
                <b>Wednesday</b>
              </div>
              <div className="ui-g-12" style={{ paddingTop: "10px" }}>
                <b>Thursday</b>
              </div>
              <div className="ui-g-12" style={{ paddingTop: "10px" }}>
                <b>Friday</b>
              </div>
              <div className="ui-g-12" style={{ paddingTop: "10px" }}>
                <b>Saturday</b>
              </div>
              <div className="ui-g-12" style={{ paddingTop: "10px" }}>
                <b>Sunday</b>
              </div>
            </div>
            <div className="ui-g-3">
              <div className="ui-g-12">
                <b>Start-Time</b>
              </div>
              <div className="ui-g-12" style={{ paddingTop: "10px" }}>
                <label>{this.state.mondayStart || "Not Set"}</label>
              </div>
              <div className="ui-g-12" style={{ paddingTop: "10px" }}>
                <label>{this.state.tuesdayStart || "Not Set"}</label>
              </div>
              <div className="ui-g-12" style={{ paddingTop: "10px" }}>
                <label>{this.state.wednesdayStart || "Not Set"}</label>
              </div>
              <div className="ui-g-12" style={{ paddingTop: "10px" }}>
                <label>{this.state.thursdayStart || "Not Set"}</label>
              </div>
              <div className="ui-g-12" style={{ paddingTop: "10px" }}>
                <label>{this.state.fridayStart || "Not Set"}</label>
              </div>
              <div className="ui-g-12" style={{ paddingTop: "10px" }}>
                <label>{this.state.saturdayStart || "Not Set"}</label>
              </div>
              <div className="ui-g-12" style={{ paddingTop: "10px" }}>
                <label>{this.state.sundayStart || "Not Set"}</label>
              </div>
            </div>
            <div className="ui-g-3">
              <div className="ui-g-12">
                <b>End-Time</b>
              </div>
              <div className="ui-g-12" style={{ paddingTop: "10px" }}>
                <label>{this.state.mondayEnd || "Not Set"}</label>
              </div>
              <div className="ui-g-12" style={{ paddingTop: "10px" }}>
                <label>{this.state.tuesdayEnd || "Not Set"}</label>
              </div>
              <div className="ui-g-12" style={{ paddingTop: "10px" }}>
                <label>{this.state.wednesdayEnd || "Not Set"}</label>
              </div>
              <div className="ui-g-12" style={{ paddingTop: "10px" }}>
                <label>{this.state.thursdayEnd || "Not Set"}</label>
              </div>
              <div className="ui-g-12" style={{ paddingTop: "10px" }}>
                <label>{this.state.fridayEnd || "Not Set"}</label>
              </div>
              <div className="ui-g-12" style={{ paddingTop: "10px" }}>
                <label>{this.state.saturdayEnd || "Not Set"}</label>
              </div>
              <div className="ui-g-12" style={{ paddingTop: "10px" }}>
                <label>{this.state.sundayEnd || "Not Set"}</label>
              </div>
            </div>
            <div className="ui-g-3">
              <div className="ui-g-12">
                <b>Closed</b>
              </div>
              <div className="ui-g-12">
                <pr.Checkbox
                  readOnly={true}
                  onChange={e => this.setState({ mondayClosed: e.checked })}
                  checked={this.state.mondayClosed}
                />
              </div>
              <div className="ui-g-12" style={{ paddingTop: "10px" }}>
                <pr.Checkbox
                  readOnly={true}
                  onChange={e => this.setState({ tuesdayClosed: e.checked })}
                  checked={this.state.tuesdayClosed}
                />
              </div>
              <div className="ui-g-12" style={{ paddingTop: "10px" }}>
                <pr.Checkbox
                  readOnly={true}
                  onChange={e => this.setState({ wednesdayClosed: e.checked })}
                  checked={this.state.wednesdayClosed}
                />
              </div>
              <div className="ui-g-12" style={{ paddingTop: "10px" }}>
                <pr.Checkbox
                  readOnly={true}
                  onChange={e => this.setState({ thursdayClosed: e.checked })}
                  checked={this.state.thursdayClosed}
                />
              </div>
              <div className="ui-g-12" style={{ paddingTop: "10px" }}>
                <pr.Checkbox
                  readOnly={true}
                  onChange={e => this.setState({ fridayClosed: e.checked })}
                  checked={this.state.fridayClosed}
                />
              </div>
              <div className="ui-g-12" style={{ paddingTop: "10px" }}>
                <pr.Checkbox
                  readOnly={true}
                  onChange={e => this.setState({ saturdayClosed: e.checked })}
                  checked={this.state.saturdayClosed}
                />
              </div>
              <div className="ui-g-12" style={{ paddingTop: "10px" }}>
                <pr.Checkbox
                  readOnly={true}
                  onChange={e => this.setState({ sundayClosed: e.checked })}
                  checked={this.state.sundayClosed}
                />
              </div>
            </div>
          </div>
        )}

        {!this.state.editingTimes ? (
          <label />
        ) : (
          <div className="ui-g card">
            <div className="ui-g-12">
              <pr.Button
                className="secondary-btn"
                icon="pi pi-times"
                onClick={() => {
                  this.setState({ editingTimes: false });
                }}
                style={{ float: "right" }}
              />
            </div>
            <div className="ui-g-3">
              <div className="ui-g-12">
                <b>&nbsp;</b>
              </div>
              <div className="ui-g-12">
                <b>Monday</b>
              </div>
              <div className="ui-g-12" style={{ paddingTop: "10px" }}>
                <b>Tuesday</b>
              </div>
              <div className="ui-g-12" style={{ paddingTop: "10px" }}>
                <b>Wednesday</b>
              </div>
              <div className="ui-g-12" style={{ paddingTop: "10px" }}>
                <b>Thursday</b>
              </div>
              <div className="ui-g-12" style={{ paddingTop: "10px" }}>
                <b>Friday</b>
              </div>
              <div className="ui-g-12" style={{ paddingTop: "10px" }}>
                <b>Saturday</b>
              </div>
              <div className="ui-g-12" style={{ paddingTop: "10px" }}>
                <b>Sunday</b>
              </div>
            </div>
            <div className="ui-g-3">
              <div className="ui-g-12">
                <b>Start-Time</b>
              </div>
              <div className="ui-g-12">
                <input
                  type="text"
                  value={this.state.editMondayStart || ""}
                  maxLength={4}
                  onKeyPress={e => {
                    this.growl.clear();
                    if (
                      e.charCode !== 48 &&
                      e.charCode !== 49 &&
                      e.charCode !== 50 &&
                      e.charCode !== 51 &&
                      e.charCode !== 52 &&
                      e.charCode !== 53 &&
                      e.charCode !== 54 &&
                      e.charCode !== 55 &&
                      e.charCode !== 56 &&
                      e.charCode !== 57
                    ) {
                      this.growl.show({
                        severity: "error",
                        summary: "Error",
                        detail: "Do not enter text",
                        life: 3000
                      });
                    }
                  }}
                  onChange={e =>
                    this.setState({ editMondayStart: e.target.value })
                  }
                  style={{ width: "100%" }}
                />
              </div>
              <div className="ui-g-12">
                <input
                  type="text"
                  value={this.state.editTuesdayStart || ""}
                  maxLength={4}
                  onKeyPress={e => {
                    this.growl.clear();
                    if (
                      e.charCode !== 48 &&
                      e.charCode !== 49 &&
                      e.charCode !== 50 &&
                      e.charCode !== 51 &&
                      e.charCode !== 52 &&
                      e.charCode !== 53 &&
                      e.charCode !== 54 &&
                      e.charCode !== 55 &&
                      e.charCode !== 56 &&
                      e.charCode !== 57
                    ) {
                      this.growl.show({
                        severity: "error",
                        summary: "Error",
                        detail: "Do not enter text",
                        life: 3000
                      });
                    }
                  }}
                  onChange={e =>
                    this.setState({ editTuesdayStart: e.target.value })
                  }
                  style={{ width: "100%" }}
                />
              </div>
              <div className="ui-g-12">
                <input
                  type="text"
                  value={this.state.editWednesdayStart || ""}
                  maxLength={4}
                  onKeyPress={e => {
                    this.growl.clear();
                    if (
                      e.charCode !== 48 &&
                      e.charCode !== 49 &&
                      e.charCode !== 50 &&
                      e.charCode !== 51 &&
                      e.charCode !== 52 &&
                      e.charCode !== 53 &&
                      e.charCode !== 54 &&
                      e.charCode !== 55 &&
                      e.charCode !== 56 &&
                      e.charCode !== 57
                    ) {
                      this.growl.show({
                        severity: "error",
                        summary: "Error",
                        detail: "Do not enter text",
                        life: 3000
                      });
                    }
                  }}
                  onChange={e =>
                    this.setState({ editWednesdayStart: e.target.value })
                  }
                  style={{ width: "100%" }}
                />
              </div>
              <div className="ui-g-12">
                <input
                  type="text"
                  value={this.state.editThursdayStart || ""}
                  maxLength={4}
                  onKeyPress={e => {
                    this.growl.clear();
                    if (
                      e.charCode !== 48 &&
                      e.charCode !== 49 &&
                      e.charCode !== 50 &&
                      e.charCode !== 51 &&
                      e.charCode !== 52 &&
                      e.charCode !== 53 &&
                      e.charCode !== 54 &&
                      e.charCode !== 55 &&
                      e.charCode !== 56 &&
                      e.charCode !== 57
                    ) {
                      this.growl.show({
                        severity: "error",
                        summary: "Error",
                        detail: "Do not enter text",
                        life: 3000
                      });
                    }
                  }}
                  onChange={e =>
                    this.setState({ editThursdayStart: e.target.value })
                  }
                  style={{ width: "100%" }}
                />
              </div>
              <div className="ui-g-12">
                <input
                  type="text"
                  value={this.state.editFridayStart || ""}
                  maxLength={4}
                  onKeyPress={e => {
                    this.growl.clear();
                    if (
                      e.charCode !== 48 &&
                      e.charCode !== 49 &&
                      e.charCode !== 50 &&
                      e.charCode !== 51 &&
                      e.charCode !== 52 &&
                      e.charCode !== 53 &&
                      e.charCode !== 54 &&
                      e.charCode !== 55 &&
                      e.charCode !== 56 &&
                      e.charCode !== 57
                    ) {
                      this.growl.show({
                        severity: "error",
                        summary: "Error",
                        detail: "Do not enter text",
                        life: 3000
                      });
                    }
                  }}
                  onChange={e =>
                    this.setState({ editFridayStart: e.target.value })
                  }
                  style={{ width: "100%" }}
                />
              </div>
              <div className="ui-g-12">
                <input
                  type="text"
                  value={this.state.editSaturdayStart || ""}
                  maxLength={4}
                  onKeyPress={e => {
                    this.growl.clear();
                    if (
                      e.charCode !== 48 &&
                      e.charCode !== 49 &&
                      e.charCode !== 50 &&
                      e.charCode !== 51 &&
                      e.charCode !== 52 &&
                      e.charCode !== 53 &&
                      e.charCode !== 54 &&
                      e.charCode !== 55 &&
                      e.charCode !== 56 &&
                      e.charCode !== 57
                    ) {
                      this.growl.show({
                        severity: "error",
                        summary: "Error",
                        detail: "Do not enter text",
                        life: 3000
                      });
                    }
                  }}
                  onChange={e =>
                    this.setState({ editSaturdayStart: e.target.value })
                  }
                  style={{ width: "100%" }}
                />
              </div>
              <div className="ui-g-12">
                <input
                  type="text"
                  value={this.state.editSundayStart || ""}
                  maxLength={4}
                  onKeyPress={e => {
                    this.growl.clear();
                    if (
                      e.charCode !== 48 &&
                      e.charCode !== 49 &&
                      e.charCode !== 50 &&
                      e.charCode !== 51 &&
                      e.charCode !== 52 &&
                      e.charCode !== 53 &&
                      e.charCode !== 54 &&
                      e.charCode !== 55 &&
                      e.charCode !== 56 &&
                      e.charCode !== 57
                    ) {
                      this.growl.show({
                        severity: "error",
                        summary: "Error",
                        detail: "Do not enter text",
                        life: 3000
                      });
                    }
                  }}
                  onChange={e =>
                    this.setState({ editSundayStart: e.target.value })
                  }
                  style={{ width: "100%" }}
                />
              </div>
            </div>
            <div className="ui-g-3">
              <div className="ui-g-12">
                <b>End-Time</b>
              </div>
              <div className="ui-g-12">
                <input
                  type="text"
                  value={this.state.editMondayEnd || ""}
                  maxLength={4}
                  onKeyPress={e => {
                    this.growl.clear();
                    if (
                      e.charCode !== 48 &&
                      e.charCode !== 49 &&
                      e.charCode !== 50 &&
                      e.charCode !== 51 &&
                      e.charCode !== 52 &&
                      e.charCode !== 53 &&
                      e.charCode !== 54 &&
                      e.charCode !== 55 &&
                      e.charCode !== 56 &&
                      e.charCode !== 57
                    ) {
                      this.growl.show({
                        severity: "error",
                        summary: "Error",
                        detail: "Do not enter text",
                        life: 3000
                      });
                    }
                  }}
                  onChange={e =>
                    this.setState({ editMondayEnd: e.target.value })
                  }
                  style={{ width: "100%" }}
                />
              </div>
              <div className="ui-g-12">
                <input
                  type="text"
                  value={this.state.editTuesdayEnd || ""}
                  maxLength={4}
                  onKeyPress={e => {
                    this.growl.clear();
                    if (
                      e.charCode !== 48 &&
                      e.charCode !== 49 &&
                      e.charCode !== 50 &&
                      e.charCode !== 51 &&
                      e.charCode !== 52 &&
                      e.charCode !== 53 &&
                      e.charCode !== 54 &&
                      e.charCode !== 55 &&
                      e.charCode !== 56 &&
                      e.charCode !== 57
                    ) {
                      this.growl.show({
                        severity: "error",
                        summary: "Error",
                        detail: "Do not enter text",
                        life: 3000
                      });
                    }
                  }}
                  onChange={e =>
                    this.setState({ editTuesdayEnd: e.target.value })
                  }
                  style={{ width: "100%" }}
                />
              </div>
              <div className="ui-g-12">
                <input
                  type="text"
                  value={this.state.editWednesdayEnd || ""}
                  maxLength={4}
                  onKeyPress={e => {
                    this.growl.clear();
                    if (
                      e.charCode !== 48 &&
                      e.charCode !== 49 &&
                      e.charCode !== 50 &&
                      e.charCode !== 51 &&
                      e.charCode !== 52 &&
                      e.charCode !== 53 &&
                      e.charCode !== 54 &&
                      e.charCode !== 55 &&
                      e.charCode !== 56 &&
                      e.charCode !== 57
                    ) {
                      this.growl.show({
                        severity: "error",
                        summary: "Error",
                        detail: "Do not enter text",
                        life: 3000
                      });
                    }
                  }}
                  onChange={e =>
                    this.setState({ editWednesdayEnd: e.target.value })
                  }
                  style={{ width: "100%" }}
                />
              </div>
              <div className="ui-g-12">
                <input
                  type="text"
                  value={this.state.editThursdayEnd || ""}
                  maxLength={4}
                  onKeyPress={e => {
                    this.growl.clear();
                    if (
                      e.charCode !== 48 &&
                      e.charCode !== 49 &&
                      e.charCode !== 50 &&
                      e.charCode !== 51 &&
                      e.charCode !== 52 &&
                      e.charCode !== 53 &&
                      e.charCode !== 54 &&
                      e.charCode !== 55 &&
                      e.charCode !== 56 &&
                      e.charCode !== 57
                    ) {
                      this.growl.show({
                        severity: "error",
                        summary: "Error",
                        detail: "Do not enter text",
                        life: 3000
                      });
                    }
                  }}
                  onChange={e =>
                    this.setState({ editThursdayEnd: e.target.value })
                  }
                  style={{ width: "100%" }}
                />
              </div>
              <div className="ui-g-12">
                <input
                  type="text"
                  value={this.state.editFridayEnd || ""}
                  maxLength={4}
                  onKeyPress={e => {
                    this.growl.clear();
                    if (
                      e.charCode !== 48 &&
                      e.charCode !== 49 &&
                      e.charCode !== 50 &&
                      e.charCode !== 51 &&
                      e.charCode !== 52 &&
                      e.charCode !== 53 &&
                      e.charCode !== 54 &&
                      e.charCode !== 55 &&
                      e.charCode !== 56 &&
                      e.charCode !== 57
                    ) {
                      this.growl.show({
                        severity: "error",
                        summary: "Error",
                        detail: "Do not enter text",
                        life: 3000
                      });
                    }
                  }}
                  onChange={e =>
                    this.setState({ editFridayEnd: e.target.value })
                  }
                  style={{ width: "100%" }}
                />
              </div>
              <div className="ui-g-12">
                <input
                  type="text"
                  value={this.state.editSaturdayEnd || ""}
                  maxLength={4}
                  onKeyPress={e => {
                    this.growl.clear();
                    if (
                      e.charCode !== 48 &&
                      e.charCode !== 49 &&
                      e.charCode !== 50 &&
                      e.charCode !== 51 &&
                      e.charCode !== 52 &&
                      e.charCode !== 53 &&
                      e.charCode !== 54 &&
                      e.charCode !== 55 &&
                      e.charCode !== 56 &&
                      e.charCode !== 57
                    ) {
                      this.growl.show({
                        severity: "error",
                        summary: "Error",
                        detail: "Do not enter text",
                        life: 3000
                      });
                    }
                  }}
                  onChange={e =>
                    this.setState({ editSaturdayEnd: e.target.value })
                  }
                  style={{ width: "100%" }}
                />
              </div>
              <div className="ui-g-12">
                <input
                  type="text"
                  value={this.state.editSundayEnd || ""}
                  maxLength={4}
                  onKeyPress={e => {
                    this.growl.clear();
                    if (
                      e.charCode !== 48 &&
                      e.charCode !== 49 &&
                      e.charCode !== 50 &&
                      e.charCode !== 51 &&
                      e.charCode !== 52 &&
                      e.charCode !== 53 &&
                      e.charCode !== 54 &&
                      e.charCode !== 55 &&
                      e.charCode !== 56 &&
                      e.charCode !== 57
                    ) {
                      this.growl.show({
                        severity: "error",
                        summary: "Error",
                        detail: "Do not enter text",
                        life: 3000
                      });
                    }
                  }}
                  onChange={e =>
                    this.setState({ editSundayEnd: e.target.value })
                  }
                  style={{ width: "100%" }}
                />
              </div>
            </div>
            <div className="ui-g-3">
              <div className="ui-g-12">
                <b>Closed</b>
              </div>
              <div className="ui-g-12">
                <pr.Checkbox
                  onChange={e => this.setState({ editMondayClosed: e.checked })}
                  checked={this.state.editMondayClosed}
                />
              </div>
              <div className="ui-g-12" style={{ paddingTop: "10px" }}>
                <pr.Checkbox
                  onChange={e =>
                    this.setState({ editTuesdayClosed: e.checked })
                  }
                  checked={this.state.editTuesdayClosed}
                />
              </div>
              <div className="ui-g-12" style={{ paddingTop: "10px" }}>
                <pr.Checkbox
                  onChange={e =>
                    this.setState({ editWednesdayClosed: e.checked })
                  }
                  checked={this.state.editWednesdayClosed}
                />
              </div>
              <div className="ui-g-12" style={{ paddingTop: "10px" }}>
                <pr.Checkbox
                  onChange={e =>
                    this.setState({ editThursdayClosed: e.checked })
                  }
                  checked={this.state.editThursdayClosed}
                />
              </div>
              <div className="ui-g-12" style={{ paddingTop: "10px" }}>
                <pr.Checkbox
                  onChange={e => this.setState({ editFridayClosed: e.checked })}
                  checked={this.state.editFridayClosed}
                />
              </div>
              <div className="ui-g-12" style={{ paddingTop: "10px" }}>
                <pr.Checkbox
                  onChange={e =>
                    this.setState({ editSaturdayClosed: e.checked })
                  }
                  checked={this.state.editSaturdayClosed}
                />
              </div>
              <div className="ui-g-12" style={{ paddingTop: "10px" }}>
                <pr.Checkbox
                  onChange={e => this.setState({ editSundayClosed: e.checked })}
                  checked={this.state.editSundayClosed}
                />
              </div>
            </div>
            <div className="ui-g-12">
              <pr.Button
                label="Save"
                onClick={() => {
                  this.updateBusinessTimes();
                  this.setState({ editingTimes: false });
                }}
                style={{ float: "right" }}
              />
              <pr.Button
                label="Cancel"
                onClick={() => {
                  this.setState({ editingTimes: false });
                }}
                style={{ float: "right" }}
              />
            </div>
          </div>
        )}

        {this.state.holidaysSelected === true ? (
          <div className="ui-g card">{this.displayHolidayTableView()}</div>
        ) : (
          <label />
        )}

        {this.state.holidayCreateView === true ? (
          <div className="ui-g card">{this.displayHolidayCreateView()}</div>
        ) : (
          <label />
        )}

        {this.state.editingNews === true ? (
          <label />
        ) : (
          <div className="ui-g-12 card">
            <div className="ui-g-12">
              <pr.Button
                className="secondary-btn"
                icon="pi pi-pencil"
                onClick={() => {
                  this.setState({
                    editingNews: true,
                    editWeeklyNews: this.state.weeklyNews
                  });
                }}
                style={{ float: "right" }}
              />
            </div>
            <div className="ui-g-12">
              <b>Weekly News</b>
            </div>
            <div className="ui-g-12">
              <textarea
                rows="10"
                readOnly={true}
                value={this.state.weeklyNews}
                style={{ width: "100%", resize: "none" }}
              />
            </div>
          </div>
        )}

        {this.state.editingNews === false ? (
          <label />
        ) : (
          <div className="ui-g-12 card">
            <div className="ui-g-12">
              <pr.Button
                className="secondary-btn"
                icon="pi pi-times"
                onClick={() => {
                  this.setState({ editingNews: false });
                }}
                style={{ float: "right" }}
              />
            </div>
            <div className="ui-g-12">
              <b>Weekly News</b>
            </div>
            <div className="ui-g-12">
              <textarea
                rows="10"
                value={this.state.editWeeklyNews}
                onChange={e =>
                  this.setState({
                    editWeeklyNews: e.target.value
                  })
                }
                style={{ width: "100%", resize: "none" }}
              />
            </div>
            <div className="ui-g-12">
              <pr.Button
                label="Save"
                onClick={() => {
                  this.updateWeeklyNews();
                  this.setState({ editingNews: false });
                }}
                style={{ float: "right" }}
              />
              <pr.Button
                label="Cancel"
                onClick={() => {
                  this.setState({ editingNews: false });
                }}
                style={{ float: "right" }}
              />
            </div>
          </div>
        )}

        {this.state.editingInformation === true ? (
          <label />
        ) : (
          <div className="ui-g-12 card">
            <div className="ui-g-12">
              <pr.Button
                className="secondary-btn"
                icon="pi pi-pencil"
                onClick={() => {
                  this.setState({
                    editingInformation: true,
                    editGeneralInformation: this.state.generalInformation
                  });
                }}
                style={{ float: "right" }}
              />
            </div>
            <div className="ui-g-12">
              <b>General Information</b>
            </div>
            <div className="ui-g-12">
              <textarea
                rows="10"
                readOnly={true}
                value={this.state.generalInformation}
                style={{ width: "100%", resize: "none" }}
              />
            </div>
          </div>
        )}

        {this.state.editingInformation === false ? (
          <label />
        ) : (
          <div className="ui-g-12 card">
            <div className="ui-g-12">
              <pr.Button
                className="secondary-btn"
                icon="pi pi-times"
                onClick={() => {
                  this.setState({ editingInformation: false });
                }}
                style={{ float: "right" }}
              />
            </div>
            <div className="ui-g-12">
              <b>General Information</b>
            </div>
            <div className="ui-g-12">
              <textarea
                rows="10"
                value={this.state.editGeneralInformation}
                onChange={e =>
                  this.setState({
                    editGeneralInformation: e.target.value
                  })
                }
                style={{ width: "100%", resize: "none" }}
              />
            </div>
            <div className="ui-g-12">
              <pr.Button
                label="Save"
                onClick={() => {
                  this.updateGeneralInformation();
                  this.setState({ editingInformation: false });
                }}
                style={{ float: "right" }}
              />
              <pr.Button
                label="Cancel"
                onClick={() => {
                  this.setState({ editingInformation: false });
                }}
                style={{ float: "right" }}
              />
            </div>
          </div>
        )}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Business/BusinessSettings.js